import { AppId, Route, createPageRoute } from '@lumapps/router';

/**
 * Before email-domains feature, this feature was the only one under the menu item "Domains management" in BO.
 * Now, email-domains is also under that menu item so "Domains management" has be renamed "Platform URLs".
 * Maybe the whole feature itself should be renamed platform-urls 🤷‍♀️️
 * */
export const domainsManagementRoute: Route = createPageRoute({
    slug: 'domains-management/platform-urls',
    appId: AppId.backOffice,
});
